/**
 * Thrown by route loaders when the user lacks the permission a page requires.
 * RouteErrorPanel renders it as "Access denied" (no Retry) instead of the
 * generic transient-failure copy — same treatment as an HTTP 403.
 */
export class ForbiddenError extends Error {
	constructor(message = "Forbidden") {
		super(message);
		this.name = "ForbiddenError";
	}
}
